import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import FileExtensionsInput from "../../FileExtensionsInput";
import { Search } from "lucide-react";

interface FileExtensionsFilterProps {
  extensions: string[];
  onExtensionsChange: (newExtensions: string[]) => void;
  onSearch?: () => void;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const FileExtensionsFilter = ({
  extensions,
  onExtensionsChange,
  onSearch,
  size = 'sm',
  className,
}: FileExtensionsFilterProps) => (
  <div className={cn("flex-1 min-w-[180px] space-y-0.5", className)}>
    <Label className="text-xs font-semibold text-muted-foreground">Extensions</Label>
    <FileExtensionsInput
      placeholder={extensions.length > 0 ? "" : ".pdf, .docx, …"}
      extensions={extensions}
      onExtensionsChange={onExtensionsChange}
      endDecorator={
        <Button
          onClick={onSearch}
          variant="ghost"
          size="xs"
          className="shrink-0 -mr-1"
        >
          <Search className="size-3" />
          Search
        </Button>
      }
    />
  </div>
);
